let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iRvkJ")).then(() => parcelRequire('9cl9P'));